import React, { FC, useEffect } from "react";
import ReactGA from "react-ga4";

export const GoogleAnalytics: FC = () => {
  useEffect(() => {
    ReactGA.initialize("G-NPR6MSFD2H");

    ReactGA.send("pageview");
  }, []);

  return <></>;
};
